export const IntroTextsActionTypes = {
  CREATE_INTRO_TEXT: '[INTRO TEXTS] Create new',
  SET_INTRO_TEXTS: '[INTRO TEXTS] Set Intro Texts',
  DELETE_INTRO_TEXT: '[INTRO TEXTS] Delete Intro Text',
  UPDATE_INTRO_TEXT: '[INTRO TEXTS] Update Intro Text',
  REMOVE_POSTAL_CODE: '[POSTAL CODES] Remove Postal Code',
  ADD_POSTAL_CODE: '[POSTAL CODES] Add Postal Code',
};
